import { DataType } from "./DataType";

export class ParameterDataType<T>
{
  type:DataType;
  parameterName:string;
  variadic:boolean = false;
  optional:boolean = false;
  defaultValue:T   = undefined;

  static from<T>( name:string, type:DataType, variadic:boolean = false, defaultValue:T = undefined )
  {
    let parameterDataType = new ParameterDataType();
    parameterDataType.type = type;
    parameterDataType.parameterName = name;
    parameterDataType.variadic = variadic 
    parameterDataType.defaultValue = defaultValue;
    parameterDataType.optional = defaultValue != undefined; 
    

    return parameterDataType;
  }
}